const workData = [
    {
        id:1,
        company:"Samsung R&D Institute India",
        role: "PRISM Developer",
        duration: "Nov 2021 - Present",
        details: " Samsung PRISM is a student program offering students a chance to develop real-world projects. The topic for my research work is medical image processing."
    },
    {
        id:2,
        company:"Center of Cyber Physical System, VIT Chennai",
        role: "Summer Research Intern",
        duration: "June 2021 - July 2021",
        details: "A research work on Skin Disease classifcation using deep learning. Devloped a model with lesser parameters and good accuracy. Paper is published in Biomedical Processing and Signal Control Journal."
    },
    {
        id:3,
        company:"IEEE Computer Society, VIT Chennai Branch",
        role: "Frontend Developer",
        duration: "July 2021 - Present",
        details: "Worked on frontend development and designing of website for the online cryptic hunt event Paradox. Technologies used were React, Javascript, Bootstrap, HTML, and CSS."
    }
]

export default workData;